export const chartsMutationTypes = {
  FANBASE_GROWTH_TABLE_LOADING: 'FANBASE_GROWTH_TABLE_LOADING',
  FANBASE_GROWTH_TABLE_ERROR: 'FANBASE_GROWTH_TABLE_ERROR',
  FANBASE_GROWTH_TABLE_DATA: 'FANBASE_GROWTH_TABLE_DATA',

  FANBASE_EVOLUTION_LOADING: 'FANBASE_EVOLUTION_LOADING',
  FANBASE_EVOLUTION_ERROR: 'FANBASE_EVOLUTION_ERROR',
  FANBASE_EVOLUTION_DATA: 'FANBASE_EVOLUTION_DATA',
  FANBASE_EVOLUTION_PERIOD: 'FANBASE_EVOLUTION_PERIOD',

  TOTAL_PUBLICATIONS_LOADING: 'TOTAL_PUBLICATIONS_LOADING',
  TOTAL_PUBLICATIONS_ERROR: 'TOTAL_PUBLICATIONS_ERROR',
  TOTAL_PUBLICATIONS_DATA: 'TOTAL_PUBLICATIONS_DATA',

  PUBLICATIONS_BY_MEDIA_TYPE_LOADING: 'PUBLICATIONS_BY_MEDIA_TYPE_LOADING',
  PUBLICATIONS_BY_MEDIA_TYPE_ERROR: 'PUBLICATIONS_BY_MEDIA_TYPE_ERROR',
  PUBLICATIONS_BY_MEDIA_TYPE_DATA: 'PUBLICATIONS_BY_MEDIA_TYPE_DATA',

  TOP_PUBLICATION_BY_CHANNEL_LOADING: 'TOP_PUBLICATION_BY_CHANNEL_LOADING',
  TOP_PUBLICATION_BY_CHANNEL_ERROR: 'TOP_PUBLICATION_BY_CHANNEL_ERROR',
  TOP_PUBLICATION_BY_CHANNEL_DATA: 'TOP_PUBLICATION_BY_CHANNEL_DATA',

  INTERACTIONS_OVER_TIME_LOADING: 'INTERACTIONS_OVER_TIME_LOADING',
  INTERACTIONS_OVER_TIME_ERROR: 'INTERACTIONS_OVER_TIME_ERROR',
  INTERACTIONS_OVER_TIME_DATA: 'INTERACTIONS_OVER_TIME_DATA',
  INTERACTIONS_OVER_TIME_PERIOD: 'INTERACTIONS_OVER_TIME_PERIOD',

  INTERACTIONS_AND_ENGAGEMENT_RATE_LOADING: 'INTERACTIONS_AND_ENGAGEMENT_RATE_LOADING',
  INTERACTIONS_AND_ENGAGEMENT_RATE_ERROR: 'INTERACTIONS_AND_ENGAGEMENT_RATE_ERROR',
  INTERACTIONS_AND_ENGAGEMENT_RATE_DATA: 'INTERACTIONS_AND_ENGAGEMENT_RATE_DATA',

  INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_LOADING: 'INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_LOADING',
  INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_ERROR: 'INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_ERROR',
  INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_DATA: 'INTERACTIONS_BY_SOCIAL_NETWORK_AND_MEDIA_TYPE_DATA',

  AVERAGE_INTERACTIONS_BY_PUBLICATION_LOADING: 'AVERAGE_INTERACTIONS_BY_PUBLICATION_LOADING',
  AVERAGE_INTERACTIONS_BY_PUBLICATION_ERROR: 'AVERAGE_INTERACTIONS_BY_PUBLICATION_ERROR',
  AVERAGE_INTERACTIONS_BY_PUBLICATION_DATA: 'AVERAGE_INTERACTIONS_BY_PUBLICATION_DATA',

  ENGAGEMENT_OVER_TIME_LOADING: 'ENGAGEMENT_OVER_TIME_LOADING',
  ENGAGEMENT_OVER_TIME_ERROR: 'ENGAGEMENT_OVER_TIME_ERROR',
  ENGAGEMENT_OVER_TIME_DATA: 'ENGAGEMENT_OVER_TIME_DATA',
  ENGAGEMENT_OVER_TIME_PERIOD: 'ENGAGEMENT_OVER_TIME_PERIOD',

  ENGAGEMENT_MATRIX_LOADING: 'ENGAGEMENT_MATRIX_LOADING',
  ENGAGEMENT_MATRIX_ERROR_DEFAULT: 'ENGAGEMENT_MATRIX_ERROR_DEFAULT',
  ENGAGEMENT_MATRIX_ERROR_PID_LIMIT: 'ENGAGEMENT_MATRIX_ERROR_PID_LIMIT',
  ENGAGEMENT_MATRIX_DATA: 'ENGAGEMENT_MATRIX_DATA',
  ENGAGEMENT_MATRIX_PERIOD: 'ENGAGEMENT_MATRIX_PERIOD',

  DISTRIBUTION_OF_INTERACTIONS_LOADING: 'DISTRIBUTION_OF_INTERACTIONS_LOADING',
  DISTRIBUTION_OF_INTERACTIONS_ERROR: 'DISTRIBUTION_OF_INTERACTIONS_ERROR',
  DISTRIBUTION_OF_INTERACTIONS_DATA: 'DISTRIBUTION_OF_INTERACTIONS_DATA',

  SENTIMENTS_IN_THE_COMMENTS_LOADING: 'SENTIMENTS_IN_THE_COMMENTS_LOADING',
  SENTIMENTS_IN_THE_COMMENTS_ERROR: 'SENTIMENTS_IN_THE_COMMENTS_ERROR',
  SENTIMENTS_IN_THE_COMMENTS_DATA: 'SENTIMENTS_IN_THE_COMMENTS_DATA',

  TERMS_MENTIONED_LOADING: 'TERMS_MENTIONED_LOADING',
  TERMS_MENTIONED_ERROR: 'TERMS_MENTIONED_ERROR',
  TERMS_MENTIONED_DATA: 'TERMS_MENTIONED_DATA',

  PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_LOADING: 'PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_LOADING',
  PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_ERROR: 'PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_ERROR',
  PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_DATA: 'PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_DATA',
  PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_PERIOD: 'PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_PERIOD',
  PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_GROUP: 'PUBLICATIONS_OVER_TIME_WITH_DISTRIBUTION_GROUP',

  SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_LOADING: 'SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_LOADING',
  SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_ERROR: 'SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_ERROR',
  SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_DATA: 'SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_DATA',
  SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_PERIOD: 'SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_PERIOD',
  SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_GROUP: 'SENTIMENTS_IN_THE_COMMENTS_OVER_TIME_GROUP',
};
